import { env } from "@/env";

// Origin of the Tournated-ID portal this Admin build talks to. Each deploy
// points `VITE_AUTH_URL` at its matching portal (localhost / dev / stage / prod),
// so the value doubles as the trusted origin for the redirect *and* for the
// `postMessage` origin check in AuthContext.provider.
//
// `HOST_TO_AUTH_BASE` is an optional override for the case where a single prod
// build is served from several staging hostnames (mirrors Tournated-Client's
// getAuthBase). Leave it empty to always use `VITE_AUTH_URL`.
const HOST_TO_AUTH_BASE: Record<string, string> = {};

export const getAuthBase = (): string => {
  const host = typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";
  return HOST_TO_AUTH_BASE[host] ?? env.authUrl;
};
